/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Time_Daysago1Inputs */

const he_time_daysago1 = /** @type {(inputs: Time_Daysago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`לפני ${i?.count}d`)
};

const en_time_daysago1 = /** @type {(inputs: Time_Daysago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d ago`)
};

/**
* | output |
* | --- |
* | "{count}d ago" |
*
* @param {Time_Daysago1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const time_daysago1 = /** @type {((inputs: Time_Daysago1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Daysago1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_time_daysago1(inputs)
	return en_time_daysago1(inputs)
});
export { time_daysago1 as "time_daysAgo" }